/* ══════════════════════════════════════════════════
   ARAMÉ — Cart Drawer
   Ajax cart drawer with luxury styling.
   ══════════════════════════════════════════════════ */

(function () {
  'use strict';

  const drawer = document.getElementById('cartDrawer');
  const overlay = document.getElementById('cartOverlay');
  const closeBtn = document.getElementById('cartDrawerClose');
  const itemsContainer = document.getElementById('cartItems');
  const subtotalEl = document.getElementById('cartSubtotal');
  const emptyState = document.getElementById('cartEmpty');
  const checkoutBtn = document.getElementById('cartCheckoutBtn');

  if (!drawer) return;

  function openDrawer() {
    fetchCart();
    drawer.classList.add('open');
    if (overlay) overlay.classList.add('open');
    document.documentElement.classList.add('lenis-stopped');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('open');
    if (overlay) overlay.classList.remove('open');
    document.documentElement.classList.remove('lenis-stopped');
    document.body.style.overflow = '';
  }

  window.addEventListener('arame:cart:open', openDrawer);

  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDrawer();
  });

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function fetchCart() {
    fetch('/cart.js')
      .then((r) => r.json())
      .then(renderCart)
      .catch(() => {});
  }

  function renderCart(cart) {
    if (!itemsContainer) return;

    if (cart.item_count === 0) {
      itemsContainer.innerHTML = '';
      if (emptyState) emptyState.style.display = 'block';
      if (subtotalEl) subtotalEl.textContent = '';
      if (checkoutBtn) checkoutBtn.style.display = 'none';
      return;
    }

    if (emptyState) emptyState.style.display = 'none';
    if (checkoutBtn) checkoutBtn.style.display = 'block';

    itemsContainer.innerHTML = cart.items.map((item) => `
      <div class="cart-item" data-key="${item.key}">
        <div class="cart-item-image">
          ${item.image ? `<img src="${item.image}" alt="${item.title}" loading="lazy" style="width:72px;height:88px;object-fit:cover;">` : ''}
        </div>
        <div class="cart-item-details">
          <p class="cart-item-title">${item.product_title}</p>
          ${item.variant_title && item.variant_title !== 'Default Title'
            ? `<p class="cart-item-variant">${item.variant_title}</p>` : ''}
          <p class="cart-item-price">${formatMoney(item.final_line_price)}</p>
          <div class="cart-item-qty">
            <button class="cart-qty-btn" data-key="${item.key}" data-delta="-1" aria-label="Decrease quantity">−</button>
            <span>${item.quantity}</span>
            <button class="cart-qty-btn" data-key="${item.key}" data-delta="1" aria-label="Increase quantity">+</button>
          </div>
          <button class="cart-item-remove" data-key="${item.key}" aria-label="Remove item">Remove</button>
        </div>
      </div>
    `).join('');

    if (subtotalEl) {
      subtotalEl.textContent = formatMoney(cart.total_price);
    }

    itemsContainer.querySelectorAll('.cart-qty-btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        const key = btn.dataset.key;
        const delta = parseInt(btn.dataset.delta, 10);
        const item = cart.items.find((i) => i.key === key);
        if (!item) return;
        const newQty = Math.max(0, item.quantity + delta);
        updateQuantity(key, newQty);
      });
    });

    itemsContainer.querySelectorAll('.cart-item-remove[data-key]').forEach((btn) => {
      btn.addEventListener('click', () => {
        updateQuantity(btn.dataset.key, 0);
      });
    });
  }

  function updateQuantity(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    })
      .then((r) => r.json())
      .then(renderCart)
      .catch(() => {});
  }

  /* Add-to-cart handler — dispatched by product sections */
  window.addEventListener('arame:cart:add', (e) => {
    const { variantId, quantity } = e.detail || {};
    if (!variantId) return;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 }),
    })
      .then((r) => r.json())
      .then(() => openDrawer())
      .catch(() => {});
  });

  /* Refresh cart count badge in header if present */
  function updateCartCount() {
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        document.querySelectorAll('[data-cart-count]').forEach((el) => {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? '' : 'none';
        });
      })
      .catch(() => {});
  }

  updateCartCount();
  window.addEventListener('arame:cart:add', () => setTimeout(updateCartCount, 600));

})();
